function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.837.074a.684.684 0 00-.92.3l-5.084 10a.684.684 0 101.219.62l5.084-10a.684.684 0 00-.3-.92zM5.186 3.368A2.596 2.596 0 002.593.775 2.596 2.596 0 000 3.368 2.596 2.596 0 002.593 5.96a2.596 2.596 0 002.593-2.593zM2.593 4.593c-.676 0-1.226-.55-1.226-1.225a1.227 1.227 0 012.451 0c0 .676-.55 1.225-1.225 1.225zM9.407 5.408A2.596 2.596 0 006.814 8a2.596 2.596 0 002.593 2.593A2.596 2.596 0 0012 8a2.596 2.596 0 00-2.593-2.593zm0 3.818c-.676 0-1.225-.55-1.225-1.225 0-.676.55-1.226 1.225-1.226a1.227 1.227 0 010 2.451z"
});

function SvgPercentage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "currentColor"
  }, props), _ref);
}

export default SvgPercentage;


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/percentage.svg
// module id = 1304
// module chunks = 10